import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'digires-slide-toggle',
  templateUrl: './digires-slide-toggle.component.html',
  styleUrls: ['./digires-slide-toggle.component.scss']
})
export class DigiresSlideToggleComponent implements OnChanges {
  @Output() onChange = new EventEmitter<MatSlideToggleChange>();

  @Input() formGroup: FormGroup;
  @Input() formCtrlName: string;
  @Input() disabled: boolean;

  @ViewChild('toggle') toggle!: MatSlideToggle;

  ngOnChanges(): void {
    const control = this.formGroup?.controls?.[this.formCtrlName];
    this.disabled ? control?.disable() : control?.enable();
  }

  toggleClicked() {
    if (!this.disabled) {
      this.toggle.toggle();
      this.onChange.emit(new MatSlideToggleChange(this.toggle, this.toggle.checked))
    }
  }
}
